
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiEnergyPetrol as ObiEnergyPetrolElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-energy-petrol.js';
 
 
 

 
 export const ObiEnergyPetrol = createComponent({
   react: React,
   tagName: 'obi-energy-petrol',
   elementClass: ObiEnergyPetrolElement,
   events: {
     
   }
  });
 
 